// React Imports
import React, { useEffect } from "react";
import {
  useNavigate,
  useNavigation,
  useActionData,
  Form,
  useSearchParams,
} from "react-router-dom";

import "../styles/Login.css";

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export async function action({ request }) {
  const formData = await request.formData();
  const username = formData.get("username");
  const password = formData.get("password");

  const response = await fetch(`${apiUrl}/ct/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-App-Secret": process.env.REACT_APP_APP_SECRET,
    },
    body: JSON.stringify({ username, password }),
  });

  const data = await response.json();

  if (response.ok) {
    localStorage.setItem("token", data.token);
    return { success: true };
  } else {
    return { error: data.error };
  }
}

export default function Login() {
  const navigate = useNavigate();
  const navigation = useNavigation();
  const data = useActionData();
  const [searchParams] = useSearchParams();

  const message = searchParams.get("message");
  const from = searchParams.get("from") || "/";

  console.log(from);

  useEffect(() => {
    console.log("Action Data: ", data);
    if (data?.success) {
      console.log(from);
      navigate("/management", { replace: true });
    }
  }, [data, from, navigate]);

  return (
    <div className="login-container">
      <div>
        {/* Renders message if user comes from anywhere other than /login */}
        {message && (
          <h3 className="font-bold text-xl text-red-600 py-2">
            {message}
            {/* {from} */}
          </h3>
        )}

        <span>Sign in to your account</span>

        {data?.error && (
          <h3 className="font-bold text-xl text-red-600 py-4">{data.error}</h3>
        )}

        <Form method="post" action="/login" className="flex flex-col gap-4">
          <input
            name="username"
            placeholder="Username"
            type="username"
            autoComplete="username"
            className="bg-gray-50 border border-gray-200 rounded-md py-2 px-4"
          />
          <input
            name="password"
            placeholder="Password"
            type="password"
            autoComplete="current-password"
            className="bg-gray-50 border border-gray-200 rounded-md py-2 px-4"
          />
          <button
            type="submit"
            disabled={navigation.state === "submitting"}
            className="bg-orange-500 disabled:bg-orange-300 text-white py-2 px-4 rounded-md font-bold text-center text-lg sm:text-xl disabled:cursor-not-allowed"
          >
            {navigation.state === "submitting" ? "Logging In..." : "Log In"}
          </button>
        </Form>
      </div>
    </div>
  );
}
